import React from 'react';
import { UiComponent } from 'components';
import { CreateAdminResultType } from 'types';
import { toast } from 'react-toastify';

interface Props {
  result: CreateAdminResultType;
  message: string;
}

// 서버가 만든 초기/임시 비밀번호를 한 번만 보여주고 복사
function PasswordResult({ result, message }: Props) {
  const copy = () =>
    navigator.clipboard
      .writeText(result.initialPassword)
      .then(() => toast.success('복사되었습니다'))
      .catch(() => toast.error('복사에 실패했습니다'));

  return (
    <div
      css={{
        width: '400px',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      <p>
        <b>{result.name || result.username}</b> ({result.username}) {message}
      </p>
      <div
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 8,
          padding: '12px 16px',
          background: '#f8f8fa',
          borderRadius: 4,
        }}
      >
        <code css={{ fontSize: 16, fontWeight: 600 }}>
          {result.initialPassword}
        </code>
        <UiComponent.Button variant="border" color="primary" onClick={copy}>
          복사
        </UiComponent.Button>
      </div>
      <p css={{ fontSize: 13, color: '#888' }}>
        이 창을 닫으면 비밀번호를 다시 볼 수 없습니다. 담당자에게 전달해주세요.
      </p>
    </div>
  );
}

export default PasswordResult;
